export const COMMENTS_REF = 'comments';

export default function (_this) {
  return {
    add (comment) {
      return new Promise((resolve) => {
        getRef().push(comment, (res) => {
          resolve(res)
        });
      })
    },
    readAll (cb) {
      getRef().once('value', (snapshot) => {
        const comments = snapshot.val() || {};
        for (let key in comments) {
          comments[key].id = key;
        }
        cb(comments);
      });
    },
    deleteAll() {
      return getRef().remove()
    },
    delete (id) {
      getRef()
        .child(id)
        .remove()
    },
    getRef
  }

  function getRef() {
    return _this.getRef(COMMENTS_REF);
  }
}
